import { render, staticRenderFns } from "./CustomerDashboard.vue?vue&type=template&id=1757aaad&"
import script from "./CustomerDashboard.vue?vue&type=script&lang=js&"
export * from "./CustomerDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports